<template>
  <router-link
    :to="{name: 'mass_pending_info', params: {massPendingId: massPendingId}}"
  >{{lable}} {{massPendingId}}</router-link>
</template>

<script>
export default {
  name: 'MassPendingLink',

  props: {
    massPendingId: {
      type: Number,
      required: true,
    },

    lable: {
      type: String,
      default: 'Mass pending',
    },
  },
};
</script>
